/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const publishTaskRequest = /* GraphQL */ `
  mutation PublishTaskRequest(
    $parameters: AWSJSON
    $sub: String
    $taskType: String
  ) {
    publishTaskRequest(
      parameters: $parameters
      sub: $sub
      taskType: $taskType
    ) {
      taskId
    }
  }
`;
export const publishTaskResult = /* GraphQL */ `
  mutation PublishTaskResult($result: PublishTaskResultInput) {
    publishTaskResult(result: $result) {
      errorMessage
      message
      result
      sub
      taskId
    }
  }
`;
export const publishTaskResultFromConsole = /* GraphQL */ `
  mutation PublishTaskResultFromConsole($result: PublishTaskResultInput) {
    publishTaskResultFromConsole(result: $result) {
      errorMessage
      message
      result
      sub
      taskId
    }
  }
`;
export const setMh1PractitionerCode = /* GraphQL */ `
  mutation SetMh1PractitionerCode(
    $appointmentBookId: Int!
    $locationId: String
    $practitionerCode: String!
  ) {
    setMh1PractitionerCode(
      appointmentBookId: $appointmentBookId
      locationId: $locationId
      practitionerCode: $practitionerCode
    ) {
      message
      status
    }
  }
`;
export const updateLinks = /* GraphQL */ `
  mutation UpdateLinks($input: LinksInput!) {
    updateLinks(input: $input) {
      accCount
      accounts {
        accountId
        baseUrl
        encryptedPassword
        mh1EasyRecalls {
          pmsSiteId
        }
        notificationChannel
        olbBooks {
          olbBookId
          pmsBookFQId
          treatmentMappings {
            olbTreatmentId
            pmsAppointmentTypeId
          }
          appointmentTypes {
             name
          }
        }
        platform
        primaryPmsSiteId
        products
        timeZone
        username
      }
      ctd
      ctdTs
      sub
    }
  }
`;
